export const userNavigation = [
    {
        name: 'Exit',
        to: '/'
    },
]